
<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small icon v-if="Number(item.total_amount) >= 3000" color="primary"><v-icon small>fa-info</v-icon></v-btn>
      </template>
      <v-card style="border-radius:12px" v-if="dialog">
        <v-card-title primary-title>
          <div class="headline mb-0">Detalhes</div>
        </v-card-title>
        <v-card-text class="py-2">
          <v-text-field v-model.lazy="item.json_attributes.extra_info.name" readonly label="Nome"
            prepend-icon="fa-user"
          ></v-text-field>

          <v-radio-group v-model="item.json_attributes.extra_info.document_kind" row mandatory>
            <v-radio readonly label="CPF" value="cpf"></v-radio>
            <v-radio readonly label="CNPJ" value="cnpj"></v-radio>
          </v-radio-group>

          <template>
            <v-text-field v-model.lazy="item.json_attributes.extra_info.document" readonly label="Documento"
              v-mask="item.json_attributes.extra_info.document_kind=='cnpj'?'##.###.###/####-##':'###.###.###-##'"
              prepend-icon="fa-id-card"
            ></v-text-field>
          </template>

          <v-text-field readonly label="CEP" type="tel" v-mask="'#####-###'" v-model="item.json_attributes.extra_info.address.zip"></v-text-field>
          <v-text-field readonly label="Rua / Avenida" v-model="item.json_attributes.extra_info.address.street"></v-text-field>
          <v-text-field readonly label="Número" v-model="item.json_attributes.extra_info.address.number"></v-text-field>
          <v-text-field readonly label="Complemento" v-model="item.json_attributes.extra_info.address.complement"></v-text-field>
          <v-text-field readonly label="Bairro" v-model="item.json_attributes.extra_info.address.neighborhood"></v-text-field>
          <v-text-field readonly label="Cidade" v-model="item.json_attributes.extra_info.address.city"></v-text-field>
          <v-text-field readonly label="Estado" v-mask="'AA'" v-model="item.json_attributes.extra_info.address.state"></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-end">
          <!-- <v-btn text color="error">Cancelar</v-btn> -->
          <v-btn text color="primary" @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'DialogPixBigValueDetails',
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
}
</script>